import { BottomSectionButton } from "components/common/BottomModal/BottomSectionButton";
import { Translate } from "components/common/Translate/Translate";
import { useAction } from "./useAction";
import { stopPropagation } from "client/utils/stopPropagation";
import { Loader } from "@/components/common/Icons/Loader/Loader";
import { useButtonLabel } from "./useButtonLabel";

export const MobileAction = () => {
    const { handleStartAction, isProcessing, processingState, dimensionsValid } = useAction();
    const isInactive = isProcessing || !dimensionsValid;
    const { getButtonLabel } = useButtonLabel(processingState, isProcessing);

    return (
        <BottomSectionButton
            className={`${isProcessing ? "cursor-progress" : "cursor-pointer"} ${
                isInactive
                    ? "bg-irGray-400 dark:bg-darkSurface-600 dark:hover:bg-darkSurface-500 hover:bg-irGray-400"
                    : "bg-irBlue-200 dark:bg-darkPrimary-100 dark:hover:bg-darkPrimary-200 hover:bg-irBlue-400"
            } `}
            active={dimensionsValid}
            onClick={stopPropagation(handleStartAction)}
        >
            {isProcessing ? getButtonLabel() : <Translate keyName="enlarge" />}
            {isProcessing ? (
                <div>
                    <div className="hidden lg:block">
                        <Loader className="stroke-white" width={32} height={32} />
                    </div>
                    <div className="lg:hidden">
                        <Loader className="stroke-white" width={24} height={24} />
                    </div>
                </div>
            ) : (
                <></>
            )}
        </BottomSectionButton>
    );
};
